import { useSelector } from "react-redux";
import { selectPageContent } from "../../../redux/selectors/settingSelector";
import { Stack, Title, Group, Button, Box, LoadingOverlay } from '@mantine/core';
import { useEffect, useState } from 'react';
import { ContentModel } from "../../../models/content.model";
import { getAllSettings, updateSetting } from "../../../redux/reducers/settingSlice";
import { SettingKey } from "../../../models/setting.model";
import { selectIsAdminOrOwner } from "../../../redux/selectors/authSelector";
import { useDispatch } from "react-redux";
import defaultContent from 'utils/data';
import colors from "utils/styles";
import EditableField from "./editable-field/editable-field";

const ContentList = () => {
  const { pageContent, loading } = useSelector(selectPageContent);
  const isAdminOrOwner = useSelector(selectIsAdminOrOwner);
  const [content, setContent] = useState(pageContent);
  const dispatch = useDispatch();

  const handleContentChange = (newContent: ContentModel) => {
    setContent(newContent as any);
  };

  const saveContent = (content: ContentModel) => {
    dispatch(updateSetting({ key: SettingKey.PAGE_CONTENT, value: content } as any));
  };

  useEffect(() => {
    setContent(pageContent);
  }, [pageContent]);

  useEffect(() => {
    dispatch(getAllSettings());
  }, []);

  return (
    <Stack p="md">
      <Group justify="space-between">
        <Title order={3}>Edit Page Content</Title>
        <Group>
          <Button variant="outline" onClick={() => setContent(defaultContent as any)} disabled={!isAdminOrOwner}>Reset Content</Button>
          <Button onClick={() => saveContent(content)} disabled={!isAdminOrOwner}>Save Content</Button>
        </Group>
      </Group>
      <Box style={{ position: 'relative' }}>
        <LoadingOverlay
          visible={loading}
          overlayProps={{ radius: "md", blur: 0.5 }}
          loaderProps={{ color: colors.appDarkBlue, type: 'bars' }}
        />
        {Object.entries(content).map(([key, value]) => (
          <EditableField
            key={key}
            label={key}
            value={value}
            onChange={(newValue) => {
              const newContent = { ...content };
              newContent[key as keyof ContentModel] = newValue;
              handleContentChange(newContent);
            }}
            path={[key]}
          />
        ))}
      </Box>
      <Button color="grey" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ position: 'fixed', bottom: 70, right: 20, zIndex: 1000 }}>Back to top</Button>
    </Stack>
  );
};

export default ContentList;
